<template>
  <layout-main-inner>
    <layout-card-wrap>
      <el-row :gutter="12">
        <el-col
          v-for="(item, index) in settings"
          :key="index"
          :span="6">
          <component
            :is="item.componentName"
            :config="item"></component>
        </el-col>
      </el-row>
    </layout-card-wrap>
  </layout-main-inner>
</template>
<script>
import CompanyBrandImageCard from './busi/company-brand-image/company-brand-image-card.vue'
import CompanyBusinessCategoryCard from './busi/company-business-category/company-business-category-card.vue'
import { settings } from './index'
export default {
  name: 'SettingsPage',
  components: { CompanyBusinessCategoryCard, CompanyBrandImageCard },
  data() {
    return { settings }
  }
}
</script>
